import React, { useState } from "react";
// import { collection, getDocs } from "firebase/firestore";
// import { db } from "../firebase";

function EditRosterModal({ roster, onSave, onClose, onDelete }) {
  const [editedName, setEditedName] = useState(roster.name || "");
  const [customFields, setCustomFields] = useState(roster.customFields || []);
  const [previewFields, setPreviewFields] = useState(roster.previewFields || []);
  const [previewTags, setPreviewTags] = useState(roster.previewTags ?? false); // Default to false
  // const [globalTags, setGlobalTags] = useState([]);

  // useEffect(() => {
  //   const fetchTags = async () => {
  //     try {
  //       const tagsCollection = collection(db, "globalTags");
  //       const tagSnapshot = await getDocs(tagsCollection);
  //       const fetchedTags = tagSnapshot.docs.map((doc) => doc.data().name);
  //       setGlobalTags(fetchedTags);
  //     } catch (error) {
  //       console.error("Error fetching tags:", error);
  //     }
  //   };

  //   fetchTags();
  // }, []);

  const handleAddField = () => {
    setCustomFields([...customFields, { name: "", type: "text" }]);
  };

  const handleFieldChange = (index, key, value) => {
    const updatedFields = [...customFields];
    updatedFields[index][key] = value;
    setCustomFields(updatedFields);
  };

  const handleDeleteField = (index) => {
    const updatedFields = customFields.filter((_, i) => i !== index);
    setCustomFields(updatedFields);

    // Ensure the deleted field is removed from previewFields
    const deletedFieldName = customFields[index].name;
    setPreviewFields(previewFields.filter((field) => field !== deletedFieldName));
  };

  const handlePreviewFieldChange = (fieldName) => {
    setPreviewFields((prev) =>
      prev.includes(fieldName)
        ? prev.filter((field) => field !== fieldName)
        : [...prev, fieldName]
    );
  };

  const handleSave = () => {
    const updatedRoster = {
      ...roster,
      name: editedName || "Untitled Roster",
      customFields: customFields.length ? customFields : [],
      previewFields: previewFields,
      previewTags: previewTags // Save selected preview tags
    };

    onSave(updatedRoster); // Persist changes via the parent component
    console.log("Updated roster to save:", updatedRoster);
    onClose();
  };

  const handleDeleteRoster = () => {
    if (window.confirm("Are you sure you want to delete this roster?")) {
      onDelete(roster.id); // Ensure onDelete is called
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>{roster.id ? "Edit Roster" : "Add Roster"}</h2>
        <label>
          Name:
          <input
            type="text"
            value={editedName}
            onChange={(e) => setEditedName(e.target.value)}
          />
        </label>
        <h3>Custom Fields</h3>
        <ul>
          {customFields.map((field, index) => (
            <li key={index} className="field-item">
              <input
                type="text"
                placeholder="Field Name"
                value={field.name}
                onChange={(e) => handleFieldChange(index, "name", e.target.value)}
              />
              <select
                className="field-type-select"
                value={field.type || "scale"} // Default to "scale"
                onChange={(e) => handleFieldChange(index, "type", e.target.value)}
              >
                <option value="scale">Scale</option>
                <option value="text">Text</option>
              </select>
              <label>
                <input
                  type="checkbox"
                  checked={previewFields.includes(field.name)}
                  onChange={() => handlePreviewFieldChange(field.name)}
                />
                Preview
              </label>
              <button
                className="delete-field-btn"
                onClick={() => handleDeleteField(index)}
              >
                ×
              </button>
            </li>
          ))}
        </ul>
        <button className="add-field-btn" onClick={handleAddField}>
          Add Field
        </button>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontSize: "16px",
            lineHeight: "1",
            height: "24px", // Adjust to match the checkbox height
          }}
        >
          <label
            htmlFor="previewTagsCheckbox"
            style={{
              display: "inline-block",
              marginRight: "150px", // Adjust spacing between text and checkbox
              whiteSpace: "nowrap", // Prevent wrapping of text
            }}
          >
            Show all tags in preview
          </label>
          <input
            id="previewTagsCheckbox"
            type="checkbox"
            checked={previewTags} // Ensure correct state binding
            onChange={() => setPreviewTags(!previewTags)}
            style={{
              transform: "scale(1.1)",
              cursor: "pointer",
            }}
          />
        </div>

        <div className="modal-actions">
          {roster.id && (
            <button className="delete-roster-btn" onClick={handleDeleteRoster}>
              Delete Roster
            </button>
          )}
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="save-btn" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditRosterModal;
